<template>
  <div class="page">
    <div class="page__header">
      <div class="page__header-title">
        User Management
        <div class="page__header-subtitle">Add and manage users</div>
      </div>

      <div class="page__header-tools">
        <b-row>
          <b-col>
            <b-form-select
              size="sm"
              v-model="roleFilter"
              :options="roleOptions"
              @change="changeUserRole"
            ></b-form-select>
          </b-col>
          <b-col>
            <b-form-input
              v-model="searchText"
              size="sm"
              placeholder="Search"
              @input="searchUser($event)"
              trim
            ></b-form-input>
          </b-col>
          <b-col>
            <b-button size="sm" variant="success" @click="openModal('add', {})">
              <i class="icon-user-plus icon"></i> Add User
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="page__body">
      <div v-if="userList.length">
        <DataGrid
          :fields="fields"
          :items="userList"
          @deleteUser="deleteUser"
          @editUser="editUser"
        />
      </div>
      <div v-if="!view.userDataLoading && !userList.length">
        <hr />
        <noData> No Data Available</noData>
      </div>
    </div>
    <loader v-if="view.userDataLoading || view.deletingUser"></loader>

    <b-modal
      modal-class="flyout__modal"
      content-class="flyout__modal-contents"
      scrollable
      hide-footer
      hide-header
      no-fade
      no-close-on-backdrop
      ref="modal-add-user"
      id="modal-add-user"
    >
      <AddUser
        @addUser="addUser"
        @updateUser="updateUser"
        @cancel="$bvModal.hide('modal-add-user')"
        :mode="addUserProp.mode"
        :user="addUserProp.user"
      />
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import AddUser from "../components/users/AddUser";
import DataGrid from "../components/DataGrid";
import noData from "../components/NoDataAvailable.vue";

const { mapGetters, mapActions } = createNamespacedHelpers("admin/usersView");

export default {
  components: {
    AddUser,
    DataGrid,
    noData,
  },

  data: function () {
    return {
      addUserProp: {
        mode: null,
        user: null,
      },
      roleOptions: [
        { text: "All Roles", value: null },
        { text: "Trainer", value: "Trainer" },
        { text: "Admin", value: "Admin" },
      ],
      roleFilter: null,
      fields: [
        { key: "firstName" },
        { key: "lastName" },
        { key: "email" },
        { key: "role" },
        { key: "Actions" },
      ],
      searchText: null,
    };
  },

  computed: {
    ...mapGetters(["userList"]),

    view() {
      return this.$store.state.admin.usersView;
    },
  },

  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setSelectedTenant") {
        this.loadUsers();
      }
    });
  },

  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
    this.loadUsers();
  },

  methods: {
    ...mapActions([
      "addUser",
      "loadUsers",
      "deleteUser",
      "updateUser",
      "changeUserRole",
      "searchUser",
    ]),

    openModal(mode, user) {
      this.addUserProp.mode = mode;
      this.addUserProp.user = JSON.parse(JSON.stringify(user));
      this.$refs["modal-add-user"].show();
    },

    editUser(user) {
      this.openModal("edit", user);
    },
  },
};
</script>
